(function () {
  'use strict';
  function repair(root) {
    root.querySelectorAll('.shopify-policy__body, [data-ps-policy-content]').forEach(function (element) {
      if (element.dataset.psPolicyReady) return;
      element.dataset.psPolicyReady = 'true';
      // Repair escaped formatting only, copying through an allowlist.
      if (!/<(?:p|h[1-6]|ul|ol|em|strong)(?:\s|>)/i.test(element.textContent)) return;
      var parsed = new DOMParser().parseFromString(element.textContent, 'text/html');
      var allowed = new Set(['P','H2','H3','H4','H5','H6','UL','OL','LI','STRONG','EM','B','I','BR','A','BLOCKQUOTE']);
      function clean(node) {
        if (node.nodeType === 3) return document.createTextNode(node.textContent);
        if (node.nodeType !== 1) return document.createDocumentFragment();
        if (['SCRIPT','STYLE','IFRAME','OBJECT','TEMPLATE'].includes(node.tagName)) return document.createDocumentFragment();
        var output = allowed.has(node.tagName) ? document.createElement(node.tagName.toLowerCase()) : document.createDocumentFragment();
        if (node.tagName === 'A') {
          var href = node.getAttribute('href') || '';
          if (/^(https?:\/\/|mailto:|\/(?!\/)|#)/i.test(href)) output.setAttribute('href', href);
        }
        Array.from(node.childNodes).forEach(function (child) { output.appendChild(clean(child)); });
        return output;
      }
      var fragment = document.createDocumentFragment();
      Array.from(parsed.body.childNodes).forEach(function (node) { fragment.appendChild(clean(node)); });
      element.replaceChildren(fragment);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { repair(document); });
  else repair(document);
  document.addEventListener('shopify:section:load', function (event) { repair(event.target); });
}());
